import { isNull } from "lodash";
import React, { useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Card } from "react-bootstrap";
import { AddToolTip } from "../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/pro-light-svg-icons";

const MappedFieldSetup = ({
  headerName,
  value,
  setShowSlideOut,
  index,
  setFieldIndex,
  item,
  hasHeader,
  showView = false,
}) => {
  const onSlideOpen = () => {
    setShowSlideOut(true);
    setFieldIndex(index);
  };
  const idx = String(index + 1).padStart(2, "0");
  const [show, setShow] = useState(false);

  return (
    <div>
      <Card
        className="mappedDataCard"
        onClick={() => {
          if (setShowSlideOut) onSlideOpen();
        }}
        style={{ cursor: "pointer" }}
      >
        {hasHeader ? (
          <div className="d-flex flex-column">
            <div className="ellipsis">
              <FontAwesomeIcon icon={faEllipsisV} size="2x" color="#828282" />
              <FontAwesomeIcon icon={faEllipsisV} size="2x" color="#828282" />
            </div>
            <span className="headerData">
              <AddToolTip name={headerName} />
            </span>
            <div className="d-flex justify-content-between">
              <p className="valueInside">Value : {value}</p>
              <p className="valueInside">{index + 1}</p>
              {/* {showView && (
                <span
                  className="ft-12 link-text-mapper fw-500"
                  onClick={() => setShow(!show)}
                >
                  {!show ? "View More" : "View Less"}
                </span>
              )} */}
            </div>
          </div>
        ) : (
          <>
            <span className="textInside mb-1">
              <AddToolTip
                name={!isNull(headerName) ? `${idx} | ${headerName}` : idx}
              />
            </span>
            <p className="valueInside mt-1">Value : {value}</p>
            <p
              style={{
                marginLeft: "290px",
                marginTop: "-20px",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "12px",
                color: "#bdbdbd",
                whiteSpace: "nowrap",
              }}
            >
              {index + 1}
            </p>
          </>
        )}
      </Card>
    </div>
  );
};

export default MappedFieldSetup;
